import { makeLazy } from "lib/make-lazy"

export const Review = makeLazy(() => import("./reviewImpl"), "ReviewImpl")
